import React from 'react';
import {reviews} from "../../model/common/Review";
import ReviewCard from "../../components/user/reviews/ReviewCard";
import {motion} from "framer-motion";
import MainDesign from "../MainDesign";
import Meta from "../../components/common/Meta";
import Heading from "../../components/common/header/Heading";
import AnimatedLink from "../../components/ui/motion/AnimatedLink";

export default function ReviewsPage() {
    // Sort reviews by date (newest first)
    const sortedReviews = [...reviews].sort((a, b) =>
        new Date(b.addedAt).getTime() - new Date(a.addedAt).getTime()
    );

    return (
        <>
            <Meta title="Opinie" description="Poznaj opinie naszych kursantów oraz podopiecznych."/>
            <MainDesign containerStyles="container pt-20 pb-24">
                <Heading badgeText='Opinie' customTitleStyles='font-heading mb-4 fs-4 text-white'
                         title='Co mówią nasi kursanci?'
                         subtitle='Nasi kursanci osiągają konkretne rezultaty dzięki stosowaniu metod, które przekazujemy
                            na kursach.
                            Poznaj ich historie i zobacz, jak możesz zmienić swoje podejście do nauki i działania.'/>

                <div className="row g-8">
                    {sortedReviews.map((review, index) => (
                        <motion.div
                            className="col-12 col-md-6 col-lg-4"
                            key={`${review.name}-${index}`}
                            initial={{opacity: 0, y: 50}}
                            animate={{opacity: 1, y: 0}}
                            transition={{duration: 0.5, delay: index * 0.1}}
                        >
                            <ReviewCard review={review}/>
                        </motion.div>
                    ))}
                </div>

                <div className="row mt-12 justify-content-center">
                    <div className="col-12 col-md-8 text-center">
                        <h3 className="fs-5 text-white mb-5">Masz pytania?</h3>
                        <p className="text-secondary-light mb-8 mw-md-3xl mx-auto fw-medium">
                            Jeżeli masz jakiekolwiek pytania dotyczące naszych kursów lub potrzebujesz więcej
                            informacji, skontaktuj się z nami. Chętnie odpowiemy na wszystkie Twoje pytania.
                        </p>
                        <AnimatedLink to="/kontakt" className="btn btn-lg btn-success">
                            Skontaktuj się z nami
                        </AnimatedLink>
                    </div>
                </div>
            </MainDesign>
        </>
    );
}
